package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

// ---------- Card shell ----------

val ResourceCardStyle = CssStyle {
    base {
        Modifier
            .width(100.percent)
            .maxWidth(360.px)
            .position(Position.Relative)
            .backgroundColor(Colors.White)
            .borderRadius(18.px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 6.px,
                blurRadius = 20.px,
                spreadRadius = 0.px,
                color = Color.rgba(15, 30, 60, 0.08f)
            )
            .styleModifier {
                property("overflow", "hidden")
                property("transition", "transform 0.35s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.35s ease")
            }
    }

    hover {
        Modifier
            .boxShadow(
                offsetX = 0.px,
                offsetY = 18.px,
                blurRadius = 36.px,
                spreadRadius = 0.px,
                color = Color.rgba(15, 30, 60, 0.16f)
            )
            .styleModifier {
                property("transform", "translateY(-6px)")
            }
    }
}

val CategoryBadgeStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.LegacyInlineFlex)
            .padding(topBottom = 5.px, leftRight = 12.px)
            .borderRadius(999.px)
            .styleModifier {
                property("font-size", "11px")
                property("font-weight", "700")
                property("letter-spacing", "0.06em")
                property("text-transform", "uppercase")
            }
    }
}

val ViewButtonStyle = CssStyle {
    base {
        Modifier
            .flexGrow(1)
            .borderRadius(10.px)
            .backgroundColor(Color.rgb(20, 40, 74))
            .color(Colors.White)
            .cursor(Cursor.Pointer)
            .styleModifier {
                property("border", "none")
                property("font-size", "14px")
                property("font-weight", "600")
                property("transition", "background-color 0.2s ease")
            }
    }
    hover {
        Modifier.backgroundColor(Color.rgb(30, 56, 98))
    }
    focusVisible {
        Modifier.styleModifier {
            property("outline", "2px solid ${Color.rgb(30, 64, 110)}")
            property("outline-offset", "2px")
        }
    }
}

val DownloadButtonStyle = CssStyle {
    base {
        Modifier
            .flexGrow(1)
            .borderRadius(10.px)
            .backgroundColor(Colors.Transparent)
            .color(Color.rgb(20, 40, 74))
            .cursor(Cursor.Pointer)
            .styleModifier {
                property("border", "1.5px solid ${Color.rgba(20, 40, 74, 0.25f)}")
                property("font-size", "14px")
                property("font-weight", "600")
                property("transition", "background-color 0.2s ease, border-color 0.2s ease")
            }
    }
    hover {
        Modifier
            .backgroundColor(Color.rgba(20, 40, 74, 0.06f))
            .styleModifier {
                property("border-color", "${Color.rgba(20, 40, 74, 0.45f)}")
            }
    }
    focusVisible {
        Modifier.styleModifier {
            property("outline", "2px solid ${Color.rgb(30, 64, 110)}")
            property("outline-offset", "2px")
        }
    }
}